import { Spin, Tooltip, Icon, message, Progress } from 'antd';
import React, { Component } from 'react';
import { connect } from "react-redux";
import { setObjectiveType, setScanName, setScanSpeed, setSpecimenType, takePreview, 
    setPreviewStatusToConfirmed, setDropDistancePointLength, setDropDistancePointOnly, 
    setFocusPoints, updatePreviewStatus, receivedPreviewStatus } from '../../../action/preview_status.action';
import { RegionSelectionConstants } from "../../../actionTypes/region_selection.constant";
import '../../../asset/style/workflow/slide.css';
import { objectiveType, scanSpeed, specimenType, C240SlideStatus, slideType } from '../../../utils/const';
import { getBarcodeCrop, getOverlayedMaskForPath } from '../c240_preview_utils';
import { setDeviceBusy, setDeviceIdle } from '../../../action/device_status.action';
import axios from 'axios';
import { ScanApiConstant } from '../../../actionTypes/scan.constant';
import cookie from "react-cookies";

let SPECIMEN = {
    'PAP': specimenType.LBC,
    'HE': specimenType.HNE_TISSUE,
    'IHC': specimenType.IHC,
    // 'Blood': specimenType.BLOOD,
}

let SCAN_SPEED = {
    'Minor': scanSpeed.FAST,
    'Few': scanSpeed.MEDIUM,
    'Major': scanSpeed.SLOW,
    'ZSTACK': scanSpeed.ZSTACK,
}

// let SCAN_SPEED_NORMAL = {
//     'Minor': scanSpeed.FAST,
//     'Few': scanSpeed.MEDIUM,
//     'Major': scanSpeed.SLOW
// }

let OBJECTIVE = {
    '20x': objectiveType.TWENTY_X,
    '40x': objectiveType.FORTY_X,
    '100x': objectiveType.HUNDRED_X,
}

const initialState = {
    tissueType: null,
    scanSpeed: null,
    objective: null,
    takePreview: false,
    isFetching: false,
}

class C240SlideView extends Component {

    constructor(props) {
        super(props);
        this.state = initialState;
    }

    componentDidMount = () => {
        this.setState({
            tissueType: this.getKeyByValue(SPECIMEN, Object.keys(this.props.preview || {}).length === 0 ? this.props.defaultConfig.specimenType : this.props.preview.specimenType),
            scanSpeed: this.getKeyByValue(SCAN_SPEED, Object.keys(this.props.preview || {}).length === 0 ? this.props.defaultConfig.scanSpeed : this.props.preview.speed),
            objective: this.getKeyByValue(OBJECTIVE, Object.keys(this.props.preview || {}).length === 0 ? this.props.defaultConfig.objectiveType : this.props.preview.objectiveType),
        });
    }

    componentDidUpdate = (prevProps) => {
        let prevPreviewStatus = (((prevProps.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response|| {}).scanPreviewStatus;
        let currPreviewStatus = (((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response|| {}).scanPreviewStatus;

        for (const [key, value] of Object.entries(currPreviewStatus)) {
            if (key === this.props.slot_id) {
                if ((prevPreviewStatus[key] === undefined && value.previewStage === RegionSelectionConstants.FETCHED_IMAGE) ||
                (prevPreviewStatus[key] !== undefined && prevPreviewStatus[key].previewStage.toLowerCase() !== RegionSelectionConstants.FETCHED_IMAGE && 
                value.previewStage.toLowerCase() === RegionSelectionConstants.FETCHED_IMAGE)) {
                    this.props.dispatch(receivedPreviewStatus(ScanApiConstant.TAKEN_PREVIEW, value.previewResponse, key));
                }

                if ((prevPreviewStatus[key] === undefined && value.previewStage === RegionSelectionConstants.CONFIRMED) ||
                (prevPreviewStatus[key] !== undefined && ((prevPreviewStatus[key].previewStage.toLowerCase() !== RegionSelectionConstants.CONFIRMED && 
                value.previewStage.toLowerCase() === RegionSelectionConstants.CONFIRMED) || 
                (prevPreviewStatus[key].previewConfirmedCount !== value.previewConfirmedCount)))) {
                    this.confirmPreviewStatus(value.previewResponse);
                }
            }
        }

        if ((prevProps.preview || {}).status !== RegionSelectionConstants.FETCHED_IMAGE 
                && (this.props.preview || {}).status === RegionSelectionConstants.FETCHED_IMAGE) {
            let reg = {
                data: { index: 0 },
                height: 100,
                isChanging: false,
                new: false,
                width: 100,
                x: 0,
                y: 0,
            };
            this.createCanvas((this.props.preview || {}).specimenType, reg);
        }
    }

    componentWillUnmount = () => {
        this.setState({
            initialState,
        });
    }

	thresholdCanvasRef = thresholdCanvas => this.thresholdCanvas = thresholdCanvas;

    createCanvas = (specimenTypeVal, reg) => {
        const thresholdContext = this.thresholdCanvas.getContext('2d');
        const thresholdImage = new Image();
		let date = new Date();
        let defaultMaskLocation = this.props.preview.response.defaultMaskLocation + "?d=" + date.getTime();
        if (specimenTypeVal === specimenType.HNE_TISSUE) {
            defaultMaskLocation = this.props.preview.response.defaultHneMaskLocation + "?d=" + date.getTime();
        } else if (specimenTypeVal === specimenType.IHC) {
            defaultMaskLocation = this.props.preview.response.defaultIhcMaskLocation + "?d=" + date.getTime();
        } else if (specimenTypeVal === specimenType.LBC) {
            defaultMaskLocation = this.props.preview.response.defaultPapMaskLocation + "?d=" + date.getTime();
        }
        thresholdImage.src = "/dev-ssd/" + defaultMaskLocation;
        thresholdImage.onload = () => {
            thresholdContext.clearRect(0, 0, this.thresholdCanvas.width, this.thresholdCanvas.height);
            thresholdContext.drawImage(thresholdImage, 0, 0, this.thresholdCanvas.width, this.thresholdCanvas.height);
            this.calculateThreshold(reg);
        }
    }

    calculateThreshold = (reg) => {
        let imageURLData = this.thresholdCanvas.toDataURL("image/jpeg");
        let x1 = parseInt((reg.x * this.props.preview.response.previewWidth) / 100.0);
        let x2 = parseInt(((reg.x + reg.width) * this.props.preview.response.previewWidth) / 100.0);
        let y1 = parseInt((reg.y * this.props.preview.response.previewHeight) / 100.0);
        let y2 = parseInt(((reg.y + reg.height) * this.props.preview.response.previewHeight) / 100.0);
        let actualReg = [x1, y1, x2, y2];

        this.props.dispatch(setDeviceBusy(this.props.device_id));
        let url = '/devices/' + this.props.device_id + "/send_threshold_image_background/?slot_id=" + this.props.slot_id;
        axios({
            method:"post",
            url : url, 
            data: {
                imgBase64: imageURLData, 
                specimenType: this.props.preview.specimenType,
                objectiveType: this.props.preview.objectiveType,
                actualRegion: actualReg,
                previewData: this.props.preview
            }
        })
        .then(response => {
            if (response.status === 200) {
                this.props.dispatch(setPreviewStatusToConfirmed(this.props.slot_id, reg, actualReg));
            }
            else {
                this.props.dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_CONFIRMING_SELECTION, response, this.props.slot_id))
                this.props.dispatch(setDeviceIdle(this.props.device_id));
                message.error("Not able to confirm preview settings. Please contact admin.", 2.5);
                this.setState({
                    isFetching: false,
                });
            }
        })
        .catch(err => {
            this.props.dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_CONFIRMING_SELECTION, err, this.props.slot_id))
            this.props.dispatch(setDeviceIdle(this.props.device_id));
            message.error("Not able to confirm preview settings. Please contact admin.", 2.5);
            this.setState({
                isFetching: false,
            });
        })
    }
    
    confirmPreviewStatus = (response) => {
        let region = this.props.preview.region !== undefined ? this.props.preview.region : {};
        let actualRegion = this.props.preview.actualRegion !== undefined ? this.props.preview.actualRegion : [];
        this.props.dispatch(setPreviewStatusToConfirmed(this.props.slot_id, region, actualRegion));
        this.props.dispatch(setDropDistancePointOnly(this.props.slot_id, response.dropDistancePoint));
        this.props.dispatch(setDropDistancePointLength(this.props.slot_id, response.dropDistancePoint));
        this.props.dispatch(setFocusPoints(this.props.slot_id, response.focusPoints));
        this.props.dispatch(setDeviceIdle(this.props.device_id));
        this.props.dispatch(updatePreviewStatus(this.props.slot_id, RegionSelectionConstants.CONFIRMED));
        this.setState({
            isFetching: false,
        });
    }

    getKeyByValue(object, value) {
        return Object.keys(object).find(key => object[key] === value);
    }

    setTissueType = (value) => {

        let isFetchingAllPreviews = false;

        let currPreviewStatus = (((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response|| {}).scanPreviewStatus;

        for (const [key, value] of Object.entries(currPreviewStatus)) {
            if (value.previewOngoing) {
                console.trace("key", key, "value", value);
                isFetchingAllPreviews = true;
                break;
            }
        }

        this.setState({
            tissueType: value,
        });

        this.props.dispatch(setSpecimenType(this.props.slot_id, SPECIMEN[value]));
        
        if (!(isFetchingAllPreviews || !((this.props.preview || {}).status === RegionSelectionConstants.CONFIRMED &&
        ((this.props.preview || {}).dropDistancePoint !== undefined && (this.props.preview || {}).dropDistancePoint.length > 0)))) {
            this.createCanvas(SPECIMEN[value], this.props.preview.region);
        }
    }

    setScanSpeed = (value) => {
        this.setState({
            scanSpeed: value,
        });
        this.props.dispatch(setScanSpeed(this.props.slot_id, SCAN_SPEED[value]));
    }

    setObjectiveType = (value) => {
        this.setState({
            objective: value
        });
        this.props.dispatch(setObjectiveType(this.props.slot_id, OBJECTIVE[value]));
    }

    takePreview = () => {
        if(!(this.props.deviceStatus[this.props.device_id] || {}).uiBusy){
            this.setState({
                isFetching: true,
            });
            this.props.dispatch(takePreview(this.props.device_id, this.props.slot_id));
        }
    }

    expandEditor = () => {
        this.props.expandedSlideView(this.props.slot_id);
    }

    setSlideName = (e) => {
        this.props.dispatch(setScanName(this.props.slot_id, e.target.value));
    }

    openScan = (e, morphle_id) => {
        window.location.href = `/v4/tissue/${morphle_id}`
    }

    render() {
        // let is_superuser = cookie.loadAll().superuser === "true";
        // const slideKey = this.props.selectedCassette + "S" + this.props.id;
        let slide_level_status = ((((this.props.deviceStatus[this.props.device_id]||{}).scanner_health||{}).scanner_response||{}).slideLevelScanPreviewStatus)
        let slideStatus = this.props.slide_status;

        let date = new Date();
        let status = (slideStatus || {}).slideState;
        let scanAreaFinalized = (slideStatus || {}).scanAreaFinalized;

        let slide = null;

        let trayKey = this.props.cassetteKey;

        let rack = parseInt(trayKey.split("T")[0].split("R")[1]);
        let tray = parseInt(trayKey.split("T")[1]);
        
        const maskForPathCacheBusterKey = this.props.maskForPathCacheBusterKey;
        let barcodeCacheBusterKey = maskForPathCacheBusterKey;

        const mockHalapi = ((( ((this.props.deviceStatus || {})[this.props.device_id] || {}).scanner_health || {}).scanner_response || {}).mockConfig || {}).mockHalapi;
        // either "true" or "false"
        const mock_halapi_str = ( mockHalapi === undefined ? false : mockHalapi ).toString();
        
        
        const mySlideType = this.props.mySlideType;
        let barcode_url = `/devices/${this.props.device_id}/get_thumbnail/?rack=${rack}&slot=${this.props.slot_id}&tray=${tray}&mock_halapi=${mock_halapi_str}&d=${barcodeCacheBusterKey}`;

        if (mySlideType === slideType.SLIDE_2_BY_3_INCH) {
            let slotid_2by3 = this.props.slot_id === 0 ? 4 : 5;  // see morpheus get_thumbnail endpoint. halapi will store slot 2 as S0 and slot 1 as S1
            barcode_url = `/devices/${this.props.device_id}/get_thumbnail/?rack=${rack}&slot=${slotid_2by3}&tray=${tray}&mock_halapi=${mock_halapi_str}&d=${barcodeCacheBusterKey}`;
        }
        if (status === C240SlideStatus.PREVIEW_DONE) {
            // preview has been taken for this slot
            // let barcode = [];
            let trayKey = this.props.cassetteKey;
            console.debug("trayKey preview done", trayKey);
            let rack = parseInt(trayKey.split("T")[0].split("R")[1]);
            let tray = parseInt(trayKey.split("T")[1]);
            // let cassetteSlideId = trayKey + "S" + this.props.slot_id;
            // barcode.push(<img key={`${cassetteSlideId}-barcode`} alt="Barcode" src={barcode_url} style={{height: "85px", width: "100px"}}></img>);
            const previewCameraBarcodeUrl = getBarcodeCrop(this.props.slot_id + 1, tray, rack) + '?d=' + barcodeCacheBusterKey;
            slide = <div className={mySlideType === slideType.SLIDE_2_BY_3_INCH ? "c240-filled-preview-container-2by3" : "c240-filled-preview-container"}
                         style={scanAreaFinalized ? {boxShadow: '0px 4px 8px 2px green'} : {boxShadow: '0px 4px 8px 2px rgba(0,0,0,0.5)'}}>
                        <Tooltip 
                            placement="rightTop" 
                            title={"Click to modify scan settings"}>
                            <div onClick={this.expandEditor} className={"filled-slide"}>
                                <p>Change Scan Region</p>
                                <img className="c240-slot-image" 
                                    src={getOverlayedMaskForPath(this.props.slot_id + 1, tray, rack) + '?d=' + maskForPathCacheBusterKey}
                                    alt="Slide Image" />
                            </div>
                        </Tooltip>
                        <div className="c240-barcode-filled" 
                            style={{ width: "85px", transform: "rotate(-90deg)", height: "112px", marginTop: "-13px", borderLeft: "1px solid gray" }}>
                            <img className="barcode-image" alt="Barcode" src={previewCameraBarcodeUrl} />
                            <div className="rotate"><Icon type="reload" /></div>
                        </div>
                        {/* <div>{is_superuser?this.props.slideState:''}</div> */}
                    </div>
        } else if (status === C240SlideStatus.INITIAL 
            || status === C240SlideStatus.PREVIEW_ONGOING 
            || status === C240SlideStatus.PREVIEW_IN_QUEUE
            || status === C240SlideStatus.AUTO_SCAN_IN_QUEUE) {
            // preview hasn't been taken for this slot
            let barcode = [];
            if (this.props.barcodeTaken) {
                let trayKey = this.props.cassetteKey;
                let cassetteSlideId = trayKey + "S" + this.props.slot_id;
                barcode.push(<img key={`${cassetteSlideId}-barcode`} alt="Barcode" src={barcode_url} style={{height: "85px", width: "100px"}}></img>);
            }
            slide = <div className={mySlideType === slideType.SLIDE_2_BY_3_INCH ? "c240-empty-unconfirmed-preview-container-2by3": "c240-empty-unconfirmed-preview-container"}
                         style={status === C240SlideStatus.PREVIEW_ONGOING ? { animation: 'shadow-pulse5 1.5s infinite' } : {}}>
                        <div className="centered empty-slide">
                            {status === C240SlideStatus.INITIAL ?
                                <div><div>Queue Preview</div>
                                <div>using button below</div>
                                {/* <div>or</div><div>Auto Scan</div> */}
                                </div>
                                : null}
                        </div>
                        <div className="c240-barcode-empty">
                            {barcode}
                        </div>
                        {/* <div>{is_superuser?this.props.slideState:''}</div> */}
                    </div>
        } else if( status === C240SlideStatus.SCAN_IN_QUEUE) {
            // let barcode = [];
            let cassetteSlideId = trayKey + "S" + this.props.slot_id;
            // if (this.props.barcodeTaken) {
            //     let trayKey = this.props.cassetteKey;
            //     barcode.push(<img key={`${cassetteSlideId}-barcode`} src={barcode_url} style={{height: "85px", width: "100px"}}></img>);
            // }
            let trayKey = this.props.cassetteKey;
            let rack = parseInt(trayKey.split("T")[0].split("R")[1]);
            let tray = parseInt(trayKey.split("T")[1]);
            const previewCameraBarcodeUrl = getBarcodeCrop(this.props.slot_id + 1, tray, rack) + '?d=' + barcodeCacheBusterKey;

            slide = <div className={mySlideType === slideType.SLIDE_2_BY_3_INCH ? "c240-empty-confirmed-preview-container-2by3": "c240-empty-confirmed-preview-container"} 
                        style={status === C240SlideStatus.SCAN_ONGOING ? { animation: 'shadow-pulse5 1.5s infinite' } : null}>
                        <div className="filled-slide" style={{cursor:'alias'}}>
                            <p>Scan In Queue</p>
                            <img className="c240-slot-image" 
                                src={getOverlayedMaskForPath(this.props.slot_id + 1, tray, rack) + '?d=' + maskForPathCacheBusterKey}
                                alt="Slide Image" />
                        </div>
                        <div className="c240-barcode-filled"
                            style={{ width: "85px", transform: "rotate(-90deg)", height: "112px", marginTop: "-13px", borderLeft: "1px solid gray" }}>
                            <img key={`${cassetteSlideId}-barcode`} className="barcode-image" alt="Barcode" src={previewCameraBarcodeUrl}/>
                        </div>
                        {/* <div>{is_superuser?this.props.slideState:''}</div> */}
                    </div>
        } else if (status === C240SlideStatus.SCAN_ONGOING) {
            // scan is going on
            // let barcode = [];
            // let cassetteSlideId = trayKey + "S" + this.props.slot_id;
            // if (this.props.barcodeTaken) {    
            //     barcode.push(<img key={`${cassetteSlideId}-barcode`} alt="Barcode" src={barcode_url} style={{height: "85px", width: "100px"}}></img>);
            // }
            let trayKey = this.props.cassetteKey;
            let rack = parseInt(trayKey.split("T")[0].split("R")[1]);
            let tray = parseInt(trayKey.split("T")[1]);
            let slide_id = this.props.cassetteKey + "S" + this.props.slot_id;
            const previewCameraBarcodeUrl = getBarcodeCrop(this.props.slot_id + 1, tray, rack) + '?d=' + barcodeCacheBusterKey;

            let percent = ((((((this.props.deviceStatus||{})[this.props.device_id]||{}).scanner_health||{}).scanner_response||{}).currentSlideLevelStats||{})[slide_id]||{}).percentDone
            slide = <div className={mySlideType === slideType.SLIDE_2_BY_3_INCH ? "c240-empty-confirmed-preview-container-2by3": "c240-empty-confirmed-preview-container"}
                        style={status === C240SlideStatus.SCAN_ONGOING ? { animation: 'shadow-pulse5 1.5s infinite' } : null}>
                        <div style={{position:'absolute', zIndex:'100', marginTop:'14vh',marginLeft:'0.7vw'}}>
                            <Progress type="circle" className="centered" 
                            percent={ (percent === undefined || percent === null || isNaN(percent) ) ? 0.00 : percent.toFixed(2) <= 85 ? percent.toFixed(2) : 85.00}
                            width={80} />
                        </div>
                        <div className="filled-slide" style={{cursor:'alias'}}>
                            <p>Scanning..</p>
                            <img className="c240-slot-image" 
                                src={getOverlayedMaskForPath(this.props.slot_id + 1, tray, rack) + '?d=' + maskForPathCacheBusterKey}
                                alt="Slide Image" />
                        </div>
                        <div className="c240-barcode-filled" 
                            style={{ width: "85px", transform: "rotate(-90deg)", height: "112px", marginTop: "-13px", borderLeft: "1px solid gray" }}>
                            <img className="barcode-image" alt="Barcode" src={previewCameraBarcodeUrl} />
                        </div>
                        {/* <div>{is_superuser?this.props.slideState:''}</div> */}
                    </div>
        } else if (this.props.slideState === C240SlideStatus.SCAN_DONE) {
            // scan completed and ready for viewing
            // let barcode = [];
            // if (this.props.barcodeTaken) {
            //     let trayKey = this.props.cassetteKey;
            //     let cassetteSlideId = trayKey + "S" + this.props.slot_id;
            //     barcode.push(<img key={`${cassetteSlideId}-barcode`} alt="Barcode" src={barcode_url} style={{height: "85px", width: "100px"}}></img>);
            // }
            let trayKey = this.props.cassetteKey;
            let rack = parseInt(trayKey.split("T")[0].split("R")[1]);
            let tray = parseInt(trayKey.split("T")[1]);
            let slide_id = this.props.cassetteKey + "S" + this.props.slot_id;
            const previewCameraBarcodeUrl = getBarcodeCrop(this.props.slot_id + 1, tray, rack) + '?d=' + barcodeCacheBusterKey;

            let morphle_id = ((((((this.props.deviceStatus||{})[this.props.device_id]||{}).scanner_health||{}).scanner_response||{}).currentSlideLevelStats||{})[slide_id]||{}).morphleID
            slide = <div onClick={(e)=>this.openScan(e, morphle_id)} className={mySlideType === slideType.SLIDE_2_BY_3_INCH ? "c240-empty-confirmed-preview-container-2by3": "c240-empty-confirmed-preview-container"}>
                        <div style={{position:'absolute', zIndex:'100', marginTop:'14vh',marginLeft:'0.7vw'}}>
                            <Progress type="circle" className="centered"
                                                percent={100} 
                            width={80} style={{cursor:'pointer'}}/>
                        </div>
                        <div onClick={null} className="filled-slide" style={{cursor:'pointer'}}>
                            <p>Click to view scan</p>
                            <img className="c240-slot-image" 
                                src={getOverlayedMaskForPath(this.props.slot_id + 1, tray, rack)+ '?d=' + maskForPathCacheBusterKey}
                                alt="Slide Image" />
                        </div>
                        <div className="c240-barcode-filled"
                            style={{ width: "85px", transform: "rotate(-90deg)", height: "112px", marginTop: "-13px", borderLeft: "1px solid gray" }}>
                            <img className="barcode-image" alt="Barcode" src={previewCameraBarcodeUrl} />
                        </div>
                        {/* <div>{is_superuser?this.props.slideState:''}</div> */}
                    </div>
        } else if (this.props.slideState === C240SlideStatus.SCAN_STITCHING) {
            // let barcode = [];
            // if (this.props.barcodeTaken) {
            //     let trayKey = this.props.cassetteKey;
            //     let cassetteSlideId = trayKey + "S" + this.props.slot_id;
            //     barcode.push(<img key={`${cassetteSlideId}-barcode`} alt="Barcode" src={barcode_url} style={{height: "85px", width: "100px"}}></img>);
            // }
            let trayKey = this.props.cassetteKey;
            let rack = parseInt(trayKey.split("T")[0].split("R")[1]);
            let tray = parseInt(trayKey.split("T")[1]);
            let slide_id = this.props.cassetteKey + "S" + this.props.slot_id;
            const previewCameraBarcodeUrl = getBarcodeCrop(this.props.slot_id + 1, tray, rack) + '?d=' + barcodeCacheBusterKey;

            let percent = ((((((this.props.deviceStatus||{})[this.props.device_id]||{}).scanner_health||{}).scanner_response||{}).currentSlideLevelStats||{})[slide_id]||{}).stitchingPercentDone
            slide = <div className={mySlideType === slideType.SLIDE_2_BY_3_INCH ? "c240-empty-confirmed-preview-container-2by3": "c240-empty-confirmed-preview-container"} 
                        style={status === C240SlideStatus.SCAN_ONGOING ? { animation: 'shadow-pulse5 1.5s infinite' } : null}>
                        <div style={{position:'absolute', zIndex:'100', marginTop:'14vh',marginLeft:'0.7vw'}}>
                            <Progress type="circle" className="centered"
                                                percent={percent?percent.toFixed(2):0} 
                            width={80} />
                        </div>
                        <div className="filled-slide" style={{cursor:'alias'}}>
                            <p>Stitching..</p>
                            <img className="c240-slot-image" 
                                src={getOverlayedMaskForPath(this.props.slot_id + 1, tray, rack) + '?d=' + date.getTime()}
                                alt="Slide Image" />
                        </div>
                        <div className="c240-barcode-filled"
                            style={{ width: "85px", transform: "rotate(-90deg)", height: "112px", marginTop: "-13px", borderLeft: "1px solid gray" }}>
                            <img className="barcode-image" alt="Barcode" src={previewCameraBarcodeUrl} />
                        </div>
                        {/* <div>{is_superuser ? this.props.slideState : ''}</div> */}
                    </div>
        } else if (this.props.slideState === C240SlideStatus.SCAN_CRASHED) {
            // scan crashed 
            // let barcode = [];
            // if (this.props.barcodeTaken) {
            //     let trayKey = this.props.cassetteKey;
            //     let cassetteSlideId = trayKey + "S" + this.props.slot_id;
            //     barcode.push(<img key={`${cassetteSlideId}-barcode`} alt="Barcode" src={barcode_url} style={{height: "85px", width: "100px"}}></img>);
            // }
            let trayKey = this.props.cassetteKey;
            let rack = parseInt(trayKey.split("T")[0].split("R")[1]);
            let tray = parseInt(trayKey.split("T")[1]);
            const previewCameraBarcodeUrl = getBarcodeCrop(this.props.slot_id + 1, tray, rack) + '?d=' + barcodeCacheBusterKey;
            
            slide = <div className={mySlideType === slideType.SLIDE_2_BY_3_INCH ? "c240-empty-unconfirmed-preview-container-2by3": "c240-empty-unconfirmed-preview-container"} 
                        style={{boxShadow: '0px 4px 8px 2px red'}}>
                
                        <div className="centered empty-slide">
                            <div>
                                <div>Scan Crashed!</div>
                                <div>Please retake</div>
                            </div>
                        </div>
                        <div className="c240-barcode-filled"
                            style={{ width: "85px", transform: "rotate(-90deg)", height: "112px", marginTop: "-13px", borderLeft: "1px solid gray" }}>
                            <img className="barcode-image" alt="Barcode" src={previewCameraBarcodeUrl} />
                        </div>
                        {/* <div>{is_superuser?this.props.slideState:''}</div> */}
                    </div>
        }

        if (slide === null || slide === undefined) {
            console.debug("slide obj is ", slide, "slideState is", this.props.slideState, "barcodeTaken is", this.props.barcodeTaken);
        }
        
        return (
            <Spin spinning={status === C240SlideStatus.PREVIEW_ONGOING || status === C240SlideStatus.PREVIEW_IN_QUEUE
                   ||  status === C240SlideStatus.SCAN_IN_QUEUE || status === C240SlideStatus.AUTO_SCAN_IN_QUEUE }
                tip={ status === C240SlideStatus.PREVIEW_ONGOING ?
                        "Taking Preview" :
                        status === C240SlideStatus.PREVIEW_IN_QUEUE ?
                            "Preview Queued" :
                            status === C240SlideStatus.SCAN_IN_QUEUE ? 
                                "Scan Queued" :
                                status === C240SlideStatus.AUTO_SCAN_IN_QUEUE ?
                                    "Auto Scan Queued" :
                                    (this.props.deviceStatus[this.props.device_id] || {}).busyMessage }>
                <div className='c240-slide-container'>
                    {slide}
                    <canvas ref={this.thresholdCanvasRef} className="region-selection-canvas-new" style={{display: 'none'}} />
                </div>
            </Spin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        preview: state.previewStatusReducer[ownProps.slot_id],
        deviceStatus: state.deviceStatusReducer,
    };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(C240SlideView);